import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { lastValueFrom } from 'rxjs';
import { FinzyService } from 'src/app/core/services/finzy.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-account-aggregator',
  templateUrl: './account-aggregator.component.html',
  styleUrl: './account-aggregator.component.scss'
})
export class AccountAggregatorComponent implements OnInit {
  bankForm!: FormGroup;

  constructor(private fb: FormBuilder, private spinner: NgxSpinnerService, private finzyService: FinzyService, private route: ActivatedRoute, private router: Router) { }
  ngOnInit(): void {
    this.spinner.hide();

    this.route.queryParamMap.subscribe(async params => {
      const status = params.get('status');
      const transId = params.get('requestid');

      if (status === 'true' && transId) {
        this.spinner.show();
        try {
          var res = await lastValueFrom(this.finzyService.UpdateAggregator({ status: 'success', transactionId: transId }));
          if (res['data'] === "success") {
            this.spinner.hide();
            return this.router.navigateByUrl('/assist-journey/f/current-address');
          }
        } catch (err) {
          if (err?.status === 401) {
            this.spinner.hide();
            this.router.navigateByUrl('/assist-journey/session-expired');
          }
        }
        this.spinner.hide();
      }
      else {
        this.spinner.show();
        try {
          var res = await lastValueFrom(this.finzyService.CheckAggregator());
          if (res['data'] === "already completed") {
            this.spinner.hide();
            return this.router.navigateByUrl('/assist-journey/f/current-address');
          }
          this.spinner.hide();
        } catch (err) {
          if (err?.status === 401) {
            this.spinner.hide();
            this.router.navigateByUrl('/assist-journey/session-expired');
          }
        }
        this.spinner.hide();
      }
    });


    this.bankForm = this.fb.group({
      accountNumber: [
        '',
        [Validators.required, Validators.pattern(/^[0-9]{9,18}$/)]
      ],
      accountType: ['', Validators.required],
      accountHolderName: ['', Validators.required],
      ifscCode: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[A-Z]{4}0[A-Z0-9]{6}$/i) // Standard IFSC format
        ]
      ]
    });
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    const isDigit = /^[0-9]$/.test(event.key);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  allowOnlyLetters(event: KeyboardEvent): void {
    const isLetterOrSpace = /^[a-zA-Z ]$/.test(event.key);
    if (!isLetterOrSpace) {
      event.preventDefault();
    }
  }


  get m() {
    return this.bankForm.controls;
  }


  async initiateAA() {
    this.spinner.show();
    if (this.bankForm.invalid) {
      this.bankForm.markAllAsTouched();
      this.spinner.hide();
      return;
    }

    const formValue = this.bankForm.value;
    try {
      var res = await lastValueFrom(this.finzyService.InitiateAA({ BankInfo: formValue }));
      if (res['data']) {

        if (res['data'] == "already completed") {
          this.spinner.hide();
          return this.router.navigateByUrl('/assist-journey/f/current-address');
        }
        this.spinner.hide();
        window.location.href = res['data'];
      }
      else {
        swal.fire('Error', 'Error initiating Account Aggregator. Please try again later.');
      }
    }
    catch (err) {
      if (err.status === 0) {
        swal.fire('Error', 'Network Error: Please check your internet connection and try again.');
        return;
      }

      if (err?.status === 401) {
        this.spinner.hide();
        this.router.navigateByUrl('/assist-journey/session-expired');
      }

      swal.fire('Error', 'Something went wrong, please try again later');

    }

    this.spinner.hide();
  }
}
